import React from 'react'
import { Box, Modal } from '@material-ui/core'
import { Button, Text } from '@resiliatech/birdsong'
import {
  ConfirmationContainer,
  ConfirmationModalButtonContainer,
  ConfirmationModalHeader,
  FlexRowColumn,
} from './EditDataConfirmationModal.styled'

type EditDataConfirmationModalProps = {
  isConfirmationModalOpen: boolean
  onCloseConfirmation: () => void
  onCloseAll: () => void
}

export const EditDataConfirmationModal = ({
  isConfirmationModalOpen,
  onCloseConfirmation,
  onCloseAll,
}: EditDataConfirmationModalProps) => (
  <Modal
    open={isConfirmationModalOpen}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    disableEnforceFocus
  >
    <ConfirmationContainer>
      <ConfirmationModalHeader>
        You have made changes to your data
      </ConfirmationModalHeader>
      <FlexRowColumn>
        <Text>Are you sure you want to close without saving?</Text>
      </FlexRowColumn>
      <Box display='flex'>
        <ConfirmationModalButtonContainer>
          <Button
            label='Confirm'
            onClick={onCloseAll}
            type='button'
            variant='tertiary'
          />
        </ConfirmationModalButtonContainer>
        <ConfirmationModalButtonContainer>
          <Button
            label='Cancel'
            onClick={onCloseConfirmation}
            type='button'
            variant='tertiary'
          />
        </ConfirmationModalButtonContainer>
      </Box>
    </ConfirmationContainer>
  </Modal>
)
